import React from "react";
import { Outlet } from "react-router-dom";
import { stratosBackgroundColor } from "src/constants/colors";
import Header from "src/components/Header/Header";
import Footer from "src/components/Footer";
import { Box } from "@mui/material";
// import SearchForm from "src/components/Header/SearchForm";
import GreenEllipse from "src/assets/images/layout/green.svg";
import PurpleEllipse from "src/assets/images/layout/purple.svg";
import styled from "styled-components";

import {
  footerHeight,
  headerHeight,
  inclusiveHeaderHeight,
  contentHeightWithoutHeaderAndFooter,
} from "src/constants/theme";

export interface IAppLayout {
  className?: string;
  children?: React.ReactNode;
}

const StyledBox = styled.div`
  overflow-x: clip;
  position: relative;
`;

// between the header and the footer
const MainContentContainer = styled.div`
  height: 100%;
  min-height: calc(100vh - ${contentHeightWithoutHeaderAndFooter});
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${GreenEllipse}), url(${PurpleEllipse});
  background-repeat: repeat-y, repeat-y;
  background-position:
    bottom 20% right -60vh,
    top 40px left -50vh;
`;

const MainContainer = styled.div`
  width: 90%;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const AppCleanLayoutWithBg: React.FC<IAppLayout> = ({
  children,
  className,
  ...props
}) => {
  return (
    <StyledBox className="app_layout_box" {...props}>
      <Header
        className="app_header"
        sx={{
          height: `${headerHeight}`,
          position: "fixed",
          width: "100%",
          zIndex: "5",
        }}
      />
      <Box
        className="app_header_inclusive_box"
        sx={{
          height: inclusiveHeaderHeight,
        }}
      />

      <MainContentContainer className="main_content_container">
        <MainContainer className="main_container">
          {/* <SearchForm /> */}
          <Outlet />
        </MainContainer>
      </MainContentContainer>

      <Footer
        backgroundColor={stratosBackgroundColor}
        footerHeight={footerHeight}
      />
    </StyledBox>
  );
};

export default AppCleanLayoutWithBg;
